import { IKeyValuePair } from "../../interfaces-and-types";
import { View } from "./View";

export interface ISummaryTableProps {
  Title: string;
  data: IKeyValuePair[];
}

export const SummaryTable = (props: ISummaryTableProps) => {
  return <View {...props} />;
};
